import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import Page from '@src/components/page';
import PageLayout from '@src/business-components/page-layout';
import AudioList from './components/audio-list';
import AudioController from './components/audio-controller';
import AuditionAudioStore from './store';
import aos from '@src/utils/aos';
const styles = require('./index.less');

const AuditionAudio = () => {
  const store = useStore(() => new AuditionAudioStore());

  return (
    <Page className={styles.mediaMusicRoot}>
      <PageLayout store={store.pageLayoutStore} title={<span className={styles.title} />}>
        <div className={styles.content} {...aos.FADE_UP()}>
          <AudioList store={store.audioListStore} />
          <AudioController store={store.audioControllerStore} />
        </div>
      </PageLayout>
    </Page>
  );
};

export default observer(AuditionAudio);
